var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full min-h-screen relative bg-dark-900 text-gray-200",attrs:{"id":"pro"}},[_c('main',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"w-full lg:w-4/5 mx-auto"},[_c('nuxt')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }